// The list of networks that are supported by Onramper can be found here:
// https://docs.onramper.com/docs/network-support
export type OnramperNetworkId = 'icp' | 'bitcoin' | 'ethereum' | 'solana' | 'base' | 'bsc' | 'polygon' | 'arbitrum';

// The list of cryptocurrencies that are supported by Onramper can be found here:
// https://docs.onramper.com/docs/crypto-asset-support
export type OnramperId = string;

// The list of fiat currencies that are supported by Onramper can be found here:
// https://docs.onramper.com/docs/fiat-currency-support
export enum Currency {
  AED = 'aed',
  BRL = 'brl',
  CAD = 'cad',
  CHF = 'chf',
  CNY = 'cny',
  EUR = 'eur',
  GBP = 'gbp',
  INR = 'inr',
  JPY = 'jpy',
  KRW = 'krw',
  NGN = 'ngn',
  SAR = 'sar',
  SGD = 'sgd',
  USD = 'usd',
  VND = 'vnd',
}

export type OnramperFiatId = Currency;

export type OnramperMode = 'buy' | 'sell' | 'swap';

export type OnramperWalletAddress = string; // add Bitcon, Ethereum

export interface OnramperCryptoWallet {
  cryptoId: OnramperId;
  wallet: OnramperWalletAddress;
}

export interface OnramperNetworkWallet {
  networkId: OnramperNetworkId;
  wallet: OnramperWalletAddress;
}
